/**
 * Showround booking error codes used across API and frontend
 */
export enum ShowroundErrorCode {
  ALREADY_BOOKED_BY_CURRENT_WEDDING = 'showround_already_booked_by_current_wedding',
  ALREADY_BOOKED_AT_SAME_TIME = 'showround_already_booked_at_same_time',
  CANNOT_BOOK_IN_THE_PAST = 'showround_cannot_book_in_the_past',
}
